import {
	StripeQueryURLParams,
	RedirectToCheckoutInput,
} from "../../../../../../common/common_utils";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { useQueryParams } from "../hooks/use_query_params";

export function StripeRedirectPage() {
	const params = useQueryParams<StripeQueryURLParams>();

	if (params.type === "checkout") {
		return (
			<RedirectToCheckout
				product_id={params.product_id}
				subscription_span={Number.parseInt(params.subscription_span)}
				should_force_no_coupon={
					params.should_force_no_coupon === "true"
				}
			/>
		);
	} else if (params.type === "manager") {
		return <RedirectToManagement />;
	}

	return <DashboardUtils.RenderFullLoadingThrobberPage />;
}

function RedirectToCheckout(props: RedirectToCheckoutInput) {
	trpc.premium.getStripeCheckoutRedirect.useQuery(props, {
		onSuccess: (data) => {
			window.location.replace(data.url);
		},
	});

	return (
		<DashboardUtils.RenderFullLoadingThrobberPage text="Redirecting to Stripe checkout..." />
	);
}

function RedirectToManagement() {
	trpc.premium.getStripeManagerRedirect.useQuery(undefined, {
		onSuccess: (data) => {
			window.location.replace(data.url);
		},
	});

	return (
		<DashboardUtils.RenderFullLoadingThrobberPage text="Redirecting to Stripe billing..." />
	);
}
